import { formatCurrency } from './formatters';

export interface CartCheckoutSummary {
  /** True when every line is by-request: no chargeable total exists, so none is shown. */
  isAwaitingQuoteOnly: boolean;
  /** "N items · $total", or "N items" alone for an all-by-request cart. */
  label: string;
}

export const summariseCartForCheckout = (
  itemCount: number,
  total: number,
  awaitingQuoteCount: number,
): CartCheckoutSummary => {
  const isAwaitingQuoteOnly = awaitingQuoteCount > 0 && awaitingQuoteCount === itemCount;
  const countLabel = `${itemCount} ${itemCount === 1 ? 'item' : 'items'}`;
  return {
    isAwaitingQuoteOnly,
    label: isAwaitingQuoteOnly ? countLabel : `${countLabel} · ${formatCurrency(total)}`,
  };
};
